<template>
  <div class="text-center secondary py-5 w-100">
    <div
      @click="openLegal()"
      class="textOverSecondary--text"
      style="cursor: pointer"
    >
      {{ $t("modals.sign_up.legal") }}
    </div>
  </div>
</template>

<script>
import lagalMixins from "@/mixins/StringUtils";
import { mapState } from "vuex";
export default {
  name: "bottom-bar",
  mixins: [lagalMixins],
  methods: {
    openLegal() {
      if (this.validURL(this.legal)) {
        window.open(this.legal);
      }
    },
  },
  computed: {
    ...mapState(["customization"]),
    legal() {
      return this.getLocalizedString(this.customization.customization.legal);
    },
  },
  created() {
    if (!this.customization.customization) {
      this.$store.dispatch("getLegalNotice", this);
    }
  },
};
</script>
